import { render, staticRenderFns } from "./TgWalletState.vue?vue&type=template&id=2d8c929b"
import script from "./TgWalletState.vue?vue&type=script&lang=js"
export * from "./TgWalletState.vue?vue&type=script&lang=js"
import style0 from "./TgWalletState.vue?vue&type=style&index=0&id=2d8c929b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports